import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { WithChildrenProps } from '@app/types/generalTypes';
import { UserRole, hasRole } from '@app/utils/role.utils';

interface RequireRoleProps extends WithChildrenProps {
  allowedRoles: UserRole | UserRole[];
  fallbackPath?: string;
}

/**
 * Component that protects routes based on user role
 * Redirects to fallback path (default: /) if user doesn't have required role
 */
const RequireRole: React.FC<RequireRoleProps> = ({ children, allowedRoles, fallbackPath = '/' }) => {
  const user = useAppSelector((state) => state.user.user);
  const location = useLocation();

  const userRole = user?.role as UserRole | undefined;

  if (!userRole || !hasRole(userRole, allowedRoles)) {
    return <Navigate to={fallbackPath} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireRole;

